import { render, staticRenderFns } from "./CardCoral.vue?vue&type=template&id=9fedc342&"
import script from "./CardCoral.vue?vue&type=script&lang=js&"
export * from "./CardCoral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports